<template>
  <v-btn :color="color"
         v-on="$listeners"
         v-bind="$attrs"
  >
    <slot>
      {{ $t('Save') }}
    </slot>
  </v-btn>
</template>

<style scoped>

</style>

<script>
  export default {
    name: 'PrimaryButton',
    inheritAttrs: false,
    data() {
      return {};
    },
    computed: {
      color() {
        return this.$attrs.color || 'primary';
      }
    },
  };
</script>

